import { Ajax } from '@bamboohr/utils';

export default async function getHasDiscountPackage(): Promise<boolean> {
	const response = await Ajax.get('/settings/cancellation/package');

	return response.data.discount_package;
}
